// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3dii_","info":"UpdateTermsInfo_info__1ysL5"};